import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';
// import { supabase } from '@/integrations/supabase/client';
import { EmployeeStatus } from '@/contexts/employees/EmployeesContext';
import { SystemUser } from "@/pages/user/hooks/useUserManagement";

const statuses = [
  { value: EmployeeStatus.ACTIVE, label: 'Active' },
  { value: EmployeeStatus.INACTIVE, label: 'Inactive' },
  { value: EmployeeStatus.SUSPENDED, label: 'Suspended' }
];

interface ChangeStatusProps {
  user: SystemUser
  onSave: (id: string, newStatus: string, reason?: string) => void
  onCancel: () => void
}

export function ChangeStatus({ user, onSave, onCancel }: ChangeStatusProps) {
  const [newStatus, setNewStatus] = useState<string>(user.status)
  const [reason, setReason] = useState("")
  
  const handleSubmit = () => {
    if (newStatus === user.status) {
      toast.info("Please select a different status.");
      return;
    }
    
    onSave(user.id, newStatus, reason)
  }
  
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold">Change Status</h2>
        <p className="text-muted-foreground">Update {user.name}'s account status</p>
      </div>
      
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Current Status</Label>
          <div className="p-2 border rounded-md bg-muted capitalize">
            {user.status}
          </div>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="new-status">New Status</Label>
          <Select value={newStatus} onValueChange={setNewStatus}>
            <SelectTrigger>
              <SelectValue placeholder="Select new status" />
            </SelectTrigger>
            <SelectContent>
              {statuses.map((status) => (
                <SelectItem key={status.value} value={status.value}>
                  {status.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="reason">Reason for Change (Optional)</Label>
          <Textarea 
            id="reason"
            placeholder="Provide a reason for this status change"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
          />
        </div>
      </div>
      
      <div className="flex justify-end gap-2 mt-6">
        <Button variant="outline" onClick={onCancel}>Cancel</Button>
        <Button 
          onClick={handleSubmit} 
          disabled={newStatus === user.status}
        >
          Change Status
        </Button>
      </div>
    </div>
  )
} 